module.exports = __webpack_public_path__ + "static/media/chongqing.f389c86d.jpg";